import { render, staticRenderFns } from "./GeneralSidebarList.vue?vue&type=template&id=9ab310bc&scoped=true"
import script from "./GeneralSidebarList.vue?vue&type=script&lang=ts"
export * from "./GeneralSidebarList.vue?vue&type=script&lang=ts"
import style0 from "./GeneralSidebarList.vue?vue&type=style&index=0&id=9ab310bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab310bc",
  null
  
)

export default component.exports